<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Autorizador" nzSubtitle=" - Lançamento de autorizadores.">
    </nz-page-header>

    <form nz-form [formGroup]="autorizadorForm" autocomplete="off" (ngSubmit)="onSubmitAutorizador()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Nome:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="nome" maxlength="45" formControlName="nome" placeholder="Nome" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Telefone:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="telefone" mask="00000000000 || 0000000000" formControlName="telefone" placeholder="(xx) 00000-0000" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Site:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="site" maxlength="255" formControlName="site" placeholder="https://exemplo.com.br" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idautorizador" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idautorizador" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>